
export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-user-heart-line',
      title: 'Individuálny prístup',
      description: 'Každému klientovi venujeme plnú pozornosť a snažíme sa pochopiť jeho jedinečné potreby a predstavy o dokonalom vzhľade.'
    },
    {
      icon: 'ri-star-line',
      title: 'Kvalitné produkty',
      description: 'Používame výhradne prémiové profesionálne produkty renomovaných značiek, ktoré šetria vaše vlasy a zabezpečujú dlhotrvajúci výsledok.'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Príjemná atmosféra',
      description: 'Náš salón je navrhnutý tak, aby ste sa u nás cítili príjemne a uvoľnene. Vytvárame priestor pre relaxáciu a pohodu.'
    },
    {
      icon: 'ri-award-line',
      title: 'Profesionálne služby',
      description: 'Tím skúsených kaderníčok s dlhoročnou praxou a pravidelnými školeniami. Sledujeme najnovšie trendy a techniky v kaderníckom umení.'
    }
  ];

  return (
    <section id="preco-si-vybrat-nas" className="py-20 px-4 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Prečo si vybrať nás</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Dôvody, prečo sú naši klienti spokojní a radi sa k nám vracajú
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="text-center group"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-amber-100 to-amber-200 rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                <i className={`${benefit.icon} text-4xl text-amber-700`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
